// const envConfig = require('dotenv').config();
const envConfig = undefined;

export const HOST_URI = (window.location.host.startsWith("localhost:")) ? "http://localhost:8888" : "";
export const DEFAULT_HOST = HOST_URI;
export const EB_REST_URI =  `${HOST_URI}/rest`;
// export const EB_REST_URI =  `${HOST_URI}`;
// export const CLOUDFLARE_PREFIX = process.env.REACT_APP_API_BASEURL ? 'https://files.reacho.com/sandbox/' : 'https://pub-38b13161a15641df8c2efe6c19f33fb3.r2.dev/sandbox/';

window.DEFAULT_HOST = DEFAULT_HOST; // Assign it to the global window object
